document.addEventListener('DOMContentLoaded', function(event) { 

   
  // scroll-section
  const Savoirplus = document.querySelectorAll('.woocommerce-product-details__short-description');
  
  if (Savoirplus.length > 0) {
    
    Savoirplus[0].addEventListener('click',function() {
      const dernierePositionDeScrollConnue = window.pageYOffset;
      const target = document.getElementById('finSection');
      animate(
        document.scrollingElement || document.documentElement,
        'scrollTop',
        '',
        dernierePositionDeScrollConnue,
        target.offsetTop, 
        800, 
        true
      );
    });

  }




});